<template>
  <div>
    <header>
      <Header msg="Header" />
      <SettingsHeader msg="SettingHeader" />
    </header>
    <main>
      <div class="setting_menu container">
        <a class="flex_center" v-on:click="gotoPage('/userdata')">
          <i class="icon-user"></i>
          <span>{{ $t("settings.Userdata") }}</span>
        </a>

        <a v-if="this.isMember" class="flex_center" v-on:click="gotoPage('/qcmoney')">
          <i class="icon-point">$</i>
          <span>{{ $t("settings.QCMoney") }}</span>
        </a>

        <a v-if="this.bizlion" class="flex_center" href="javascript:" v-on:click="goToBizlion()"><i class="icon-lion"></i> <span>商業獅點數查詢</span></a>

        <a class="flex_center" v-on:click="gotoPage('/notify')">
          <i class="icon-notifications"></i>
          <span>{{ $t("settings.Notification") }}</span>
        </a>
        <a class="flex_center" v-on:click="gotoPage('/pushlist')">
          <i class="icon-pushlist"></i>
          <span>{{ $t("settings.Pushlist") }}</span>
        </a>
        <a class="flex_center" v-on:click="gotoPage('/services')">
          <i class="icon-contact"></i>
          <span>{{ $t("settings.CustomerServices") }}</span>
        </a>
        <a class="flex_center" v-on:click="gotoPage('/system')">
          <i class="icon-setting"></i>
          <span>系統版本</span>
        </a>
        <a class="flex_center" v-if="sdkType === 'sso'" v-on:click="signout()">
          <i class="icon-sign-out"></i>
          <span>登出</span>
        </a>
        
      </div>
    </main>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
import Header from "@/components/Header.vue";
import SettingsHeader from "@/components/SettingsHeader.vue";
import apis from "@/services/apis";

export default {
  name: "home",
  data() {
    return {
      "isMember": false,
      "bizlion": null
    }
  },
  components: {
    Header,
    SettingsHeader
  },
  computed: {
    sdkType() {
      if (GLOBAL_ENV_SDKTYPE === 'sso')
        return 'sso';
      else
        return 'liff';
    },
    userProfile() {
      try {
        let obj = JSON.parse(
          Base64.decode(localStorage.getItem("lineUserProfile"))
        );
        // console.log('try ' + localStorage.getItem('lineUserProfile'));
        // console.log('the decode data ' + Base64.decode(localStorage.getItem("lineUserProfile")));

        return obj;
      } catch (e) {
        console.log('try but failed')
        return {};
      }
    }
  },
  methods: {
    signout() {
      console.log('check liff ' + typeof liff);
      if (liff) {
        console.log('logout');
        if (GLOBAL_ENV_SDKTYPE === "sso") {
          liff.logout();
          // 清空portal暫存的資料
          localStorage.removeItem('qcsso:uuid');
          localStorage.removeItem('lineUserProfile');
          localStorage.removeItem('lineUserId');
          this.$router.go(this.$router.currentRoute)
        }
      }
    },
    gotoPage(path) {
      this.$router.push({
        path: path,
        query: this.$router.currentRoute.query
      });
    },
    goToBizlion() {
      if (this.userProfile && this.userProfile.phone) {
        window.location.href = '/accounts/' + this.$router.currentRoute.query.s + '/bizlion?phone=' + this.userProfile.phone;
      }
    },
    isQCMoneyMember() { // 如果是快金會員，要顯示快金頁面
      // 查看user資訊
      console.log('phone ', this.userProfile);
      if (this.userProfile && this.userProfile.phone) {
        console.log('go qcmoney');
        apis.checkQCMoney(this.userProfile.phone)
        .then((response) => {
          console.log('the qcmoney response ', response);
          if (response && response.isMember)
            this.isMember = true;

          console.log('qcmoney', response);
        })
        .catch((e) => {
          console.log('qcmoney failed ' + e.stack);
        })
      }
    },
    getQCMoneyExchangesByShopId() {
      let self = this;
      if (this.$router.currentRoute.query.s) {
        console.log("get campaign shop id");
        apis
          .getQCMoneyExchangesByShopId(
            this.$router.currentRoute.query.s,
            this.userProfile.phone
          )
          .then((responses) => {
            console.log("the qcmoney exchange response ", responses);
            // 理論上應該可以有多家兌換管道，但現在先只處理一間（介面的關係）
            if (!responses)
              return;
            for (let i = 0; i < responses.length; ++i) {
              console.log('go ' +responses[i].vendor );
              if (responses[i].vendor === 'bizlion') {
                self.bizlion = responses[i];
              }
            }
            
          })
          .catch((e) => {
            console.log("exchange failed ", e);
          });
      }
    },
  },
  mounted() {
    console.info("App this router:", this.$router);
    console.info("App currentRoute:", this.$router.currentRoute);
    console.log('check user ');
    this.isQCMoneyMember();
    this.getQCMoneyExchangesByShopId();
  }
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
</style>
